import { callGetApiv2, callPostApiv2 } from "./api";

// The staff member's own store: the stale "All Stores" report flag zeroes the selectedstoreid header.
const ownStore = () => localStorage.getItem("selectedStore");

export async function getLoveForwardChecks(customerId) {
  return callGetApiv2(`love-forward/admin/customers/${customerId}/checks?store_id=${ownStore()}`);
}

export async function giveLoveForwardBouquet(customerId) {
  return callPostApiv2(`love-forward/admin/customers/${customerId}/bouquet`, { store_id: ownStore() });
}
